var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "header",
      { staticClass: "gnb", on: { mouseleave: _vm.btnCloseUserPop } },
      [
        _c("div", { staticClass: "header_wrap" }, [
          _c("div", { staticClass: "left" }, [
            ["SUPPORT", "CS", "VLDPS"].includes(_vm.loginSystem)
              ? _c("h1", [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        srcset: "/static/images/logo-mo.png",
                        media: "(max-width: 767px)"
                      }
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        srcset: "/static/images/logo.png",
                        media: "(max-width: 1023px)"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: "/static/images/logo.png",
                        alt: "Service Knowledge Portal"
                      }
                    })
                  ])
                ])
              : _c("h1", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.moveMenu()
                        }
                      }
                    },
                    [
                      _c("picture", [
                        _c("source", {
                          attrs: {
                            srcset: "/static/images/logo-mo.png",
                            media: "(max-width: 767px)"
                          }
                        }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            srcset: "/static/images/logo.png",
                            media: "(max-width: 1023px)"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: "/static/images/logo.png",
                            alt: "Service Knowledge Portal"
                          }
                        })
                      ])
                    ]
                  )
                ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "all",
                attrs: { href: "javascript:", title: "all Menu" }
              },
              [_c("span", { staticClass: "sr_only" }, [_vm._v("all Menu")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "nav" }, [
              _c(
                "a",
                {
                  staticClass: "ico_home",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("FIELD.GLOBAL.PAGEINFO.HOME")
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveMenu()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "sr_only" }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.PAGEINFO.HOME")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "dropdown scroll" },
                [
                  _vm._l(_vm.topMenus, function(menu) {
                    return _c(
                      "li",
                      { class: menu.pcOnlyYn === "Y" ? "pc_only" : "dir" },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mypage(menu.menuId),
                                expression: "mypage(menu.menuId)"
                              }
                            ],
                            attrs: { href: "javascript:", menuId: menu.menuId },
                            on: {
                              click: function($event) {
                                return _vm.clickParent($event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(menu.menuNm))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown_wrap" }, [
                          _c("dl", [
                            _c("dt", [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(menu.menuNm) +
                                  "\n                                    "
                              )
                            ]),
                            _vm._v(" "),
                            menu.groupMenu
                              ? _c(
                                  "dd",
                                  _vm._l(menu.groupMenu, function(groups) {
                                    return _c(
                                      "ul",
                                      { staticClass: "group" },
                                      [
                                        _vm._l(groups, function(gMenu) {
                                          return gMenu.subMenu.length === 0 &&
                                            gMenu.connUrl !== undefined
                                            ? _c(
                                                "li",
                                                {
                                                  class: {
                                                    pc_only:
                                                      gMenu.pcOnlyYn === "Y"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "javascript:"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.moveMenu(
                                                            gMenu
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(gMenu.menuNm)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm._l(groups, function(gMenu) {
                                          return gMenu.subMenu.length > 0
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "dir",
                                                  class: {
                                                    pc_only:
                                                      gMenu.pcOnlyYn === "Y"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "javascript:",
                                                        menuId: gMenu.menuId
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickParent(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(gMenu.menuNm)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass: "sub_group"
                                                    },
                                                    [
                                                      _vm._l(
                                                        gMenu.subMenu,
                                                        function(sub) {
                                                          return sub.subMenu
                                                            .length === 0
                                                            ? _c("li", [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href:
                                                                        "javascript:"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.moveMenu(
                                                                          sub
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        sub.menuNm
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        gMenu.subMenu,
                                                        function(sub) {
                                                          return sub.subMenu
                                                            .length > 0
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "dir",
                                                                  class: {
                                                                    pc_only:
                                                                      sub.pcOnlyYn ===
                                                                      "Y"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:",
                                                                        menuId:
                                                                          sub.menuId
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.clickParent(
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          sub.menuNm
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "ul",
                                                                    {
                                                                      staticClass:
                                                                        "sub_group"
                                                                    },
                                                                    _vm._l(
                                                                      sub.subMenu,
                                                                      function(
                                                                        ssub
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.moveMenu(
                                                                                      ssub
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    ssub.menuNm
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        })
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("li", { staticClass: "tabmobile_only" }, [
                    _vm.loginSystem !== "SUPPORT"
                      ? _c(
                          "a",
                          {
                            staticClass: "link_support",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("TITLE.LEFT.MENU.SUPPORT")
                            },
                            on: { click: _vm.btnSupport }
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.SUPPORT"))),
                            _c("em")
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "link_support",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("TITLE.LEFT.MENU.KNOWLEDGE")
                            },
                            on: { click: _vm.btnSupport }
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.KNOWLEDGE"))),
                            _c("em")
                          ]
                        )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "ui_close",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.uiCloseEvt()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "sr_only" }, [
                    _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "nav_btm" }, [
                _c(
                  "a",
                  {
                    staticClass: "ico_lnb_logout",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.logout }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LOGOUT")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "ico_lnb_notice",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnNotice }
                  },
                  [
                    _vm.noticeCount > 0
                      ? _c(
                          "em",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.noticeCount))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("TITLE.NOTICE.TITLE")) +
                          "\n                            "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "ico_lnb_setting",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnMySetting }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(
                        _vm._s(_vm.$t("TITLE.MYKNOWLEDGE.USERPREFERENCES"))
                      )
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "function_wrap" }, [
            _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "ico_allmenu",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnAllMenu }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.ALL.MENU")))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                "SUPPORT" !== _vm.loginSystem
                  ? _c(
                      "a",
                      {
                        staticClass: "ico_search",
                        attrs: { href: "javascript:" },
                        on: { click: _vm.btnSearch }
                      },
                      [
                        _c("span", { staticClass: "sr_only" }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SEARCH")))
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "ico_notice",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnNotice }
                  },
                  [
                    _vm.noticeCount > 0
                      ? _c("em", [_vm._v(_vm._s(_vm.noticeCount))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("TITLE.NOTICE.TITLE")))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.showUserPop ? "active" : "" }, [
                _c(
                  "a",
                  {
                    staticClass: "ico_user",
                    attrs: { href: "javascript:" },
                    on: { mouseover: _vm.btnToggleUserPop }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USER")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "user_layer" }, [
                  _c("li", { staticClass: "user_info" }, [
                    _vm._v(
                      "[" +
                        _vm._s(_vm.getLoginUser.companyName) +
                        "] " +
                        _vm._s(_vm.getLoginUser.loginName)
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: { click: _vm.btnMySetting }
                      },
                      [
                        _c("i", { staticClass: "ico_setting_gnb" }),
                        _vm._v(
                          _vm._s(_vm.$t("TITLE.MYKNOWLEDGE.USERPREFERENCES"))
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: { click: _vm.logout }
                      },
                      [
                        _c("i", { staticClass: "ico_logout_gnb" }),
                        _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LOGOUT")))
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "confidential" }, [
                  _vm._v("Confidential")
                ])
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dim" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ec3b2d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec3b2d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/SKPGnb.vue
// module id = +uc0
// module chunks = 0